// src/components/ChangePasswordModal.jsx
import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    FormLabel,
    Input,
    useToast,
    Spinner,
} from '@chakra-ui/react';
import axios from 'axios';
import api from '../../contexts/api';

export function ChangePasswordModal({ isOpen, onClose, userEmail }) {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const toast = useToast();

    const handleSubmit = async () => {
        setLoading(true);

        console.log(userEmail,
            currentPassword,
            newPassword);

        try {
            await api.post('/change-password', {
                email: userEmail,
                currentPassword,
                newPassword,
            });
            window.alert('Senha alterada com sucesso.');
            onClose();
            setCurrentPassword('');
            setNewPassword('');
        } catch (err) {
            window.alert(
                err.response?.data?.message ||
                'Não foi possível alterar a senha.'
            );
            // onClose();
            // setCurrentPassword('');
            // setNewPassword('');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Alterar Senha</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <FormControl mb={4}>
                        <FormLabel>Senha Atual</FormLabel>
                        <Input
                            type="password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            placeholder="Digite sua senha atual"
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Nova Senha</FormLabel>
                        <Input
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Digite a nova senha"
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button mr={3} onClick={onClose} isDisabled={loading}>
                        Cancelar
                    </Button>
                    <Button
                        colorScheme="blue"
                        onClick={handleSubmit}
                        isLoading={loading}
                        disabled={!currentPassword || !newPassword}
                    >
                        Confirmar
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
